import { render, staticRenderFns } from "./Self_assesment.vue?vue&type=template&id=4b9d4592"
import script from "./Self_assesment.vue?vue&type=script&lang=js"
export * from "./Self_assesment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports